var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-top row"},[_c('div',{staticClass:"col-4"}),_c('div',{staticClass:"col-7"}),_c('div',{staticClass:"col-1 padding-none"},[_c('NoticeArea')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }